module.exports = __webpack_public_path__ + "static/media/nav-top-bg.beb6f34c.svg";